<div class="d-flex flex-column w-100 row">
  <input-label class="col" [label]="'Contacts.V2.tags' | translate" />

  <div class="d-flex flex-wrap">
    <div class="col-12 col-md-6">
      <ng-select
        #select
        ngSelectExtension
        class="new-select tags-select"
        bindLabel="name"
        bindValue="value"
        [ngClass]="{ disabled: tagsLoading() }"
        [loading]="tagsLoading()"
        [addTagText]="'Contacts.V2.addTag' | translate"
        [formControl]="form()?.get(CONTACT_FORM.tagIds)"
        [placeholder]="'Contacts.V2.tagsPlaceholder' | translate"
        [items]="tags"
        [addTag]="true"
        [multiple]="true"
        [closeOnSelect]="false"
        (scrollToEnd)="fetchMoreTags()"
        [enableSort]="false"
        (search)="onSearch($event)"
        [inputAttrs]="{ maxlength: '200' }"
        [addNewItemFunction]="addTagFn.bind(this)"
        dropdownPosition="top"
      >
        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear"></ng-template>
        <ng-template ng-option-tmp let-item="item" let-item$="item$">
          <svg-icon *ngIf="item$.selected" src="/assets/img/check-checked-icon.svg" />
          <div *ngIf="!item$.selected" class="not-selected"></div>
          <span>{{ item.name }}</span>
          <button *ngIf="!item.isPredefined" (click)="removeTagFromApi(item.value, $event)">
            <svg-icon src="/assets/img/ic-trash-red-v2.svg" />
          </button>
        </ng-template>
      </ng-select>
    </div>
    <div [ngClass]="'col-12 col-md-6 mt-3 mt-md-0'">
      <div class="tags-container">
        <div class="pill-tag" *ngFor="let tag of selectedTags">
          {{ tag.label }}
          <button (click)="removeSelectedTag(tag.value.value)">
            <svg-icon src="/assets/img/ic-close-white-v2.svg" />
          </button>
        </div>
        <span *ngIf="selectedTags.length === 0" class="control-v2-info">-</span>
      </div>
    </div>
  </div>
</div>
